export default "__VITE_ASSET__CM0PW3O5__"